import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportPlayerActivityResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportPlayerActivityInner() {
    return <PlayerLevelReportBase tab="playerActivity" columnsSettingsViewType="PlayerLevelReportPlayerActivity" />;
}

const PlayerLevelReportPlayerActivityWithAccess = withAccessCheck(
    PlayerLevelReportPlayerActivityInner,
    playerLevelReportPlayerActivityResource
);

export const PlayerLevelReportPlayerActivity = withTraceErrorBoundary(PlayerLevelReportPlayerActivityWithAccess, ErrorModal);
